import { LoadingSequences } from 'lib/data/providers/IDataProvider';
import Cache from 'lib/utils/Cache';
import React, { useEffect, useState } from 'react';

const LoadingProgress = ({ loaded, customText }) => {
    if (customText) {
        return <div className="loading-message">{customText}</div>;
    }

    let currProgress = Cache.get('page-loader-step-progress') || 0;
    const [progress, setProgress] = useState(currProgress);

    useEffect(() => {
        if (!loaded) {
            let timerId = setTimeout(() => {
                if (progress < LoadingSequences.length - 1) {
                    setProgress(progress + 1);
                    Cache.set('page-loader-step-progress', progress + 1);
                } else {
                    setProgress(LoadingSequences.length - 1);
                    Cache.set('page-loader-step-progress', LoadingSequences.length - 1);
                }
            }, Math.random() * 2900 + 100);

            return () => {
                clearTimeout(timerId);
            };
        }
    }, [progress]);

    return <div className="loading-message">{showText ? LoadingSequences[progress] : loaderText ? loaderText : ""}</div>;
};

const Loader = ({ loaded, showText = true, customText = undefined, size = undefined }) => {
    return (
        <div className={`showbox` + (size ? ` size-${size}` : ``) + (showText ? ` has-text` : ``)}>
            <LoaderRing />
            {showText && <div className="message">{customText}</div>}
        </div>
    );
};

export const LoaderRing = ({ size = undefined }) => (
    <div className={`loader-ring` + (size ? ` size-${size}` : ``)}>
        <svg className="circular" viewBox="25 25 50 50">
            <defs>
                <linearGradient id="linearColors" x1="0" y1="0" x2="1" y2="1">
                    <stop offset="0%" stopColor="#06C2FC"></stop>
                    <stop offset="60%" stopColor="#0398FD"></stop>
                    <stop offset="100%" stopColor="#027FFE"></stop>
                </linearGradient>
            </defs>

            <circle
                className="path"
                cx="50"
                cy="50"
                r="20"
                fill="none"
                strokeWidth="1"
                strokeMiterlimit="10"
                stroke="url(#linearColors)"
            />
        </svg>
    </div>
);

export default Loader;
